export default {
  // 圖片MIMETypes限制
  pictureMIMETypesLimit: [
    'image/jpeg',
    'image/png',
    'image/gif',
  ],
  pictureExtensionsLimit: [
    'jpg',
    'jpeg',
    'png',
    'gif',
  ],
};
